import axios from 'axios';

interface EvaluateFlagResponse {
  value: boolean;
  matched_branch_index: number | null;
  fallback: string;
}

interface ApiEnvelope<T> {
  data: T;
  error: null;
}

interface EvaluateFlagBody {
  key?: string;
  metadata?: Record<string, unknown>;
}

function extractFlagValue(
  payload: EvaluateFlagResponse | ApiEnvelope<EvaluateFlagResponse>,
): boolean {
  if ('data' in payload) {
    return payload.data.value;
  }

  return payload.value;
}

export async function evaluateFlag(
  flagName: string,
  key?: string,
  metadata?: Record<string, unknown>,
): Promise<boolean> {
  const apiUrl = import.meta.env.VITE_FEATURE_FLAGS_API_URL;
  const apiKey = import.meta.env.VITE_FEATURE_FLAGS_API_KEY;

  // Return false (disabled) when no real flag service is configured
  if (!apiUrl || apiUrl.includes('example.com') || !apiKey) {
    return false;
  }

  const hasBody = key !== undefined || metadata !== undefined;
  const body: EvaluateFlagBody | undefined = hasBody ? { key, metadata } : undefined;

  const response = await axios.post<EvaluateFlagResponse | ApiEnvelope<EvaluateFlagResponse>>(
    `${apiUrl}/api/v1/sdk/flags/${flagName}/evaluate`,
    body,
    {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    },
  );

  return extractFlagValue(response.data);
}
